/* template */
<template><div class="cate-goods-list ate-goods-lis_algorithm"><template v-for="(item, index) in (goods)"><good-card :key="item['{{ item.good_id }}']" :good-info="(item)" :lang="(GlobalEnv.lang)" shadow @good-click="onGoodClick(item)" class="good-card-item"/><div ref="sentinel" class="sentinel" v-if="(goods.length > 3 ? index === goods.length - 3 : index === 0)"/></template><loading v-if="(showLoading)"/><empty v-if="(!showLoading && !goods.length)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m1db71026"}'>
.cate-goods-list
  padding-top 20rpx
.sentinel
  width 1px
  height 1px

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { GlobalEnv } from '../../../../lib/webx'
import { TrackMap } from '../../../../lib/webx/common_methods/track_map'
import { MixinList } from '../mixin'

createComponent({
  name: 'AllByAlgorithmGoodsList',
  mixins: [ MixinList ],
  properties: {
    hasRecommend: {
      type: Boolean,
      value: false,
    },
  },
  async attached() {
    await this.getGoods()
    TrackMap.index.listGoodsExposed.call(this, this.goods)
  },
  data: {
    GlobalEnv,
    goods: [],
    page: 1,
    finish: false,
    showLoading: false,
  },
  methods: {
    async getGoods() {
      this.showLoading = true
      const { lists, count } = await this.$getGoodsByCates(this.cate, this.page) || {}
      this.goods = lists || []
      this.finish = this.goods.length >= count
      this.page += 1
      this.showLoading = false
      this.observeSentinel()
    },
    // 必须实现，翻页要用
    async loadMore() {
      if (this.finish) return
      this.showLoading = true
      const { lists, count } = await this.$getGoodsByCates(this.cate, this.page) || {}
      this.goods.push(...(lists || []))
      this.finish = this.goods.length >= count
      this.page += 1
      this.showLoading = false
      this.observeSentinel()
      if (!this._loadMoreTrackCounter) {
        this._loadMoreTrackCounter = 1
      }
      if (this._loadMoreTrackCounter < 3) {
        TrackMap.index.nextPage({
          row_type: this._loadMoreTrackCounter,
        })
        this._loadMoreTrackCounter += 1
      }
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "all_by_algorithm_goods_list1db71026",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'good-card':getComponent(require("../../../../../node_modules/@didi/trade-sdk/lib/quartz/ui/good_card/index.mpx?component=true&componentId=index4ce63343")),'loading':getComponent(require("./loading.mpx?component=true&componentId=loadingd8a157b0")),'empty':getComponent(require("./empty.mpx?component=true&componentId=empty04f86cf9"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
